import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

export const getEditCountersignersAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (
    getIsAQuoteTemplate(prevState) ||
    !prevState.data.quote.isSignaturesEnabled ||
    !prevState.data.quote.isInternalSignerEnabled
  ) {
    return {
      available: { visible: false, enabled: false },
      reasons: []
    }
  }

  if (prevState.data.quote.runningQuoteApprovalAutomationExecutionId) {
    return {
      available: { visible: true, enabled: false },
      reasons: [
        { reasonType: DisabledReasonType.PendingApproval, metadata: {} }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: ![
        CubeStatus.QuotePreparingSignatureRequest,
        CubeStatus.QuoteAccepted,
        CubeStatus.QuoteExecuted
      ].includes(prevState.data.common.status)
    },
    reasons: []
  }
}
